import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const CustomHeaderComponent = styled.tr`
  align-items: center;
  padding: 12px 24px;
  height: 40px;
  background: #f8f8f8;
  font-family: 'Cera Pro';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #6a6a6a;
`;

export const CustomHeaderCellComponent = styled.td`
  padding-left: 16px;
  color: #6a6a6a;
`;

export const CustomBodyRowComponent = styled.tr`
  align-items: flex-start;
  height: 72px;
`;

export const CustomBodyCellComponent = styled.td`
  padding-left: 12px;
`;

export const NoDataContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 48px 0px;

  background: #ffffff;
  border-radius: 8px;
`;

export const NoDataLogo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 8px;
`;

export const Shade = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  width: 60px;
  height: 60px;
  background: #f0f0f0;
  border-radius: 80px;
`;

export const Message = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 0px 0px;
`;

export const Title = styled.div`
  font-family: 'Cera Pro';
  font-style: normal;
  font-size: 18px;
  line-height: 24px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #282828;
`;

export const Detail = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #6a6a6a;
`;
